"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("../components/form/types");
function sortBy(items, property) {
    return items.sort(function (a, b) {
        return a[property].toLowerCase() < b[property].toLowerCase() ? -1 : 1;
    });
}
exports.sortBy = sortBy;
function isArray(test) {
    if (test === undefined || test === null) {
        return false;
    }
    return test.constructor === Array;
}
exports.isArray = isArray;
function isObject(test) {
    if (test === undefined || test === null) {
        return false;
    }
    return test.constructor === Object;
}
exports.isObject = isObject;
function isNumber(str) {
    return /^(0|[1-9]\d*)$/.test(str);
}
function deepSet(obj, field, value) {
    var path = field.split(".");
    var key;
    var newObj = obj;
    if (!obj) {
        newObj = isNumber(path[0]) ? [] : {};
    }
    if (!isNumber(path[0]) && !isObject(newObj)) {
        console.warn("Error in deepSet(): you should not deep set a string field on an array", path[0]);
    }
    var cursor = newObj;
    while ((key = path.shift()) && path.length > 0) {
        var nextKey = path[0];
        if (!cursor[key]) {
            cursor[key] = isNumber(nextKey) ? [] : {};
        }
        if (!isNumber(nextKey) && !isObject(cursor[key])) {
            console.warn("Error in deepSet(): you should not deep set a string field '" + nextKey + "' on an array");
        }
        cursor = cursor[key];
    }
    cursor[key] = value;
    return newObj;
}
exports.deepSet = deepSet;
function deepGet(ob, field, fallback) {
    var tracer = ob;
    var path = field.split(".");
    for (var i = 0; i < path.length; i += 1) {
        var key = isNumber(path[i]) ? parseInt(path[i], 10) : path[i];
        if (i === path.length - 1) {
            return tracer[key] === undefined ? fallback : tracer[key];
        }
        if (tracer[key] === undefined) {
            return fallback;
        }
        tracer = tracer[key];
    }
}
exports.deepGet = deepGet;
function deepClone(original) {
    if (typeof original !== "object") {
        console.warn("Error in deepClone(): you cannot deep clone something that's not an object or array");
        return original;
    }
    var out = Array.isArray(original) ? [] : {};
    for (var key in original) {
        var v = original[key];
        out[key] = typeof v === "object" ? deepClone(v) : v;
    }
    return out;
}
exports.deepClone = deepClone;
/**
 * Take an object and return a new one with keys renamed.
 *
 * @param keysMap - The map of keys to rename { originalA: "renamedA", originalB: "renamedB" }.
 * @param original - The object to remap.
 * @returns The renamed copy of the object.
 */
function renameObjectKeys(keysMap, original) {
    if (typeof keysMap !== "object" || typeof original !== "object") {
        console.warn("Error in renameObjectKeys(): you cannot rename keys on something that's not an object or array");
        return original;
    }
    var renamed = Object.keys(original).reduce(function (acc, key) {
        var _a;
        return (__assign({}, acc, (_a = {}, _a[keysMap[key] || key] = original[key], _a)));
    }, {});
    return renamed;
}
exports.renameObjectKeys = renameObjectKeys;
/**
 * Take an array of objects and return a new one with keys renamed.
 *
 * @param keysMap - The map of keys to rename { originalA: "renamedA", originalB: "renamedB" }.
 * @param originalArray - The array of objects to remap.
 * @returns New array of objects with renamed keys.
 */
function renameObjectKeysInArray(keysMap, originalArray) {
    if (typeof keysMap !== "object") {
        console.warn("Error in renameObjectKeysInArray(): you cannot pass in a non-object for keysMap");
        return originalArray;
    }
    if (!isArray(originalArray)) {
        console.warn("Error in renameObjectKeysInArray(): you cannot pass in a non-array for originalArray");
        return originalArray;
    }
    var renamedArray = originalArray.map(function (val) {
        return Array.isArray(val)
            ? renameObjectKeysInArray(keysMap, val)
            : renameObjectKeys(keysMap, val);
    });
    return renamedArray;
}
exports.renameObjectKeysInArray = renameObjectKeysInArray;
/**
 * Take an object and shallow clone it.
 *
 * @param original - The object to copy.
 *
 * @returns The copy of the object.
 */
function shallowClone(original) {
    if (typeof original !== "object" || Array.isArray(original)) {
        throw new Error("Error in shallowClone(): you cannot shallow clone something that's not an object");
    }
    return Object.assign({}, original);
}
exports.shallowClone = shallowClone;
/**
 * Generates an array sequence of desired size with elements corresponding to the index
 * @param length the number of items in the new array
 */
function seq(length) {
    return Array.from(Array(length).keys());
}
exports.seq = seq;
function preventDefault(e) {
    e.preventDefault();
}
exports.preventDefault = preventDefault;
function truncate(fullText, length) {
    if (!fullText && fullText !== "")
        return undefined;
    if (fullText.length <= length) {
        return fullText;
    }
    return "..." + fullText.slice(fullText.length - length, fullText.length);
}
exports.truncate = truncate;
/**
 * https://stackoverflow.com/a/105074/96898
 * Do not use this if you need compliant GUIDs.
 */
function uniqueGUID() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return (s4() +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        "-" +
        s4() +
        s4() +
        s4());
}
exports.uniqueGUID = uniqueGUID;
/**
 * Evaluate whether two arrays are equal (order of elements matters).
 */
function arraysAreEqual(a1, a2) {
    // identity equal, or both undefined
    if (a1 === a2) {
        return true;
    }
    return (!!a1 &&
        !!a2 &&
        a1.length === a2.length &&
        a1.every(function (item, i) { return item === a2[i]; }));
}
exports.arraysAreEqual = arraysAreEqual;
/**
 * @param encoding Encoding when reading text content
 */
function readFile(file, dataType, encoding) {
    return new Promise(function (resolve, reject) {
        var fileReader = new FileReader();
        var onload = function (e) {
            resolve(e.target.result);
        };
        var onerror = function (e) {
            reject(e);
        };
        fileReader.addEventListener("load", onload);
        fileReader.addEventListener("error", onerror);
        if (dataType === types_1.ContentReaderDataType.EncodedData) {
            fileReader.readAsDataURL(file);
        }
        else {
            fileReader.readAsText(file, encoding);
        }
    });
}
exports.readFile = readFile;
function coerceArray(value) {
    return Array.isArray(value) ? value : [value];
}
exports.coerceArray = coerceArray;
// Cross-browser event creation since IE11/Edge don't support new Event
function createNewEvent(eventName) {
    var event;
    if (typeof Event === "function") {
        event = new Event(eventName);
    }
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, true, true);
    }
    return event;
}
exports.createNewEvent = createNewEvent;
exports.ariaProps = function (_a) {
    var label = _a.label, busy = _a.busy, checked = _a.checked, controls = _a.controls, current = _a.current, describedBy = _a.describedBy, labelledBy = _a.labelledBy, multiselecTable = _a.multiselecTable, pressed = _a.pressed;
    return (__assign({}, (label && { "aria-label": label }), (busy && { "aria-busy": busy }), (checked && { "aria-checked": checked }), (controls && { "aria-controls": controls }), (current && { "aria-current": current }), (describedBy && { "aria-describedby": describedBy }), (labelledBy && { "aria-labelledby": labelledBy }), (multiselecTable && { "aria-multiselectable": multiselecTable }), (pressed && { "aria-pressed": pressed })));
};
//# sourceMappingURL=util.js.map